import { apiSlice } from "../apiSlice";

export const bulkDealSparesPriorityMutationApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    updateBulkSparesPriority: builder.mutation({
      query: ({ seller_id, lot_id }) => ({
        url: "bulk_deals/spares/priority",
        method: "PATCH",
        params: {
          seller_id,
          lot_id,
        },
      }),

      // 🔑 Important: refetch affected data
      invalidatesTags: ["bulk_deals_Spare__Sellers", "InventoryLots"],
    }),
  }),
});

export const { useUpdateBulkSparesPriorityMutation } =
  bulkDealSparesPriorityMutationApi;